<template>
    <v-row class="view-data-model">
        <v-col cols="2">
            <timeline-container
                :modelisations="modelisations"
                :schema="schema"
                :save-disabled="modelsToCheck.length > 0 || isReadOnly"
                :selected-modelisation="selectedModelisation"
                style="height: calc( 100vh - ( 64px + 48px ))"
                @switch-modelisation="switchModelisation"
                @save-previous-model="savePreviousModel"
            ></timeline-container>
        </v-col>
        <v-col cols="10" style="position: relative;">
            <data-model-toolbar
                style="z-index: 10;"
                :schema="schema"
                :available-models="availableModels"
                :toggle-edit-type="toggleEditType"
                :models-changed="modelsToCheck"
                :read-only="isReadOnly"
                @save-schema="saveSchema"
                @switch-view-type="toggleEditType = $event"
                @trigger-correction="triggerCorrection"
                @save-previous-model="savePreviousModel"
                @focus-node="focusNode"
            ></data-model-toolbar>
            <div class="schema-container">
                <graph
                    :schema="schema"
                    ref="graph"
                    style="height: calc( 100vh - ( 64px + 48px  + 48px))"
                    height="calc( 100vh - ( 64px + 48px  + 48px))"
                    @save-previous-model="savePreviousModel"
                ></graph>
                <schema-editor
                    ref="schema-editor"
                    v-if="toggleEditType === 0 && currentModelisation !== null"
                    v-model="schema"
                    style="height: calc( 100vh - ( 64px + 48px + 48px))"
                    :read-only="isReadOnly"
                    @addModelToChanges="addModelToChanges"
                    @removeModelFromChanges="removeModelFromChanges"
                    @save="saveSchema"
                ></schema-editor>
                <form-editor
                    ref="form-editor"
                    v-if="toggleEditType === 1"
                    :schema="schema"
                    :read-only="isReadOnly"
                ></form-editor>
            </div>
        </v-col>
        <v-dialog
            light
            v-model="importFileDialogOpen"
            width="500"
            :persistent="true"
        >
            <v-card>
                <v-card-title
                    class="headline"
                    primary-title
                >
                    {{$t('instance.data_model.index.import.dialog_title')}}
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model='uploadedFile'
                        :label="$t('instance.data_model.index.import.field_label')"
                        prepend-icon='attach_file'
                        @click="pickFile"
                    ></v-text-field>
                    <input
                        type="file"
                        style="display: none"
                        ref="image"
                        accept=".yaml, .yml, .json"
                        @change="onFilePicked"
                    >
                    <v-alert
                        v-if="importedFileHasError"
                        type="error"
                    >
                        {{$t('instance.data_model.index.import.error_text')}}
                    </v-alert>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="info"
                        class="dialog-confirm-buttons"
                        text
                        @click="importFileDialogOpen = false"
                    >
                        {{$t('instance.data_model.index.import.cancel_btn')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <dialog-confirm
            ref="modal-unsaved-change"
            :text="$t('instance.data_model.index.dialog_confirm.text')"
            :title="$t('instance.data_model.index.dialog_confirm.title')"
            :text-confirm="$t('instance.data_model.index.dialog_confirm.confirm')"
            :text-decline="$t('instance.data_model.index.dialog_confirm.decline')"
        >
        </dialog-confirm>
        <dialog-notify ref="data-model-error" title="Data model error">
            <p slot="content">{{$t('instance.data_model.index.dialog_notify.content')}} </p>
        </dialog-notify>
        <modal-check-datamodel
            ref="modal-check-datamodel"
            @datamodel-imported-successfully="onModelisationCheckSuccessfully"
        ></modal-check-datamodel>
    </v-row>
</template>
<script>
import SchemaEditor from './SchemaEditor/index.vue';
import TimelineContainer from './timeline-container.vue';
import FormEditor from './FormEditor';
import Graph from './graph-modelisation.vue';
import DataModelToolbar from './data-model-toolbar.vue';
import YAML from 'yaml';
import DialogConfirm from '@/components/Partials/dialog-confirm.vue';
import DialogNotify from '@/components/Partials/dialog-notify.vue';
import { diff } from 'deep-diff';
import ModalCheckDatamodel from './modal-check-datamodel.vue';
export default {

    components: {
        TimelineContainer,
        SchemaEditor,
        FormEditor,
        Graph,
        DataModelToolbar,
        DialogConfirm,
        DialogNotify,
        ModalCheckDatamodel,
    },

    props: {
        modelisations: {
            type: Array,
            required: true,
        },
        schema: {
            type: Object,
            required: true,
        },
        selectedModelisation:{
            type: Object,
        }
    },
    data (){
        return {
            modelsToCheck: [],
            currentModelisation: null,
            toggleEditType: 1,
            svgScale: 1,
            uploadedFile: null,
            importFileDialogOpen: false,
            importedFileHasError: false,
            modalDatamodelCheckOpen: false,
        };
    },

    computed: {
        availableModels (){
            return this.models.map(model => {return {name: model.name, value: model.uid }});
        },

        models (){
            if(Object.keys(this.schema).length === 0) return [];
            return this.schema.schema.manifest.data_modeling.models;
        },
        isReadOnly() {
            return this.currentModelisation ? !this.currentModelisation.editable : true;
        },

    },

    watch: {
        '$parent.isActive' (val){
            if(val === false) return;
            // doit faire ça car sinon le rendu de graph ne ce fait pas bien il faut donc appelé le 'draw' au focus de la table
            this.$refs.graph.buildGraph();
        },
        toggleEditType (val, oldVal){
            if(val === undefined) this.toggleEditType = oldVal;
        },
        importFileDialogOpen (val){
            if(val === false) this.importedFileHasError = false;
        },
    },


    mounted (){
        this.$eventBus.$on('update-data-model', (value) => {
            this.$emit('update-schema-modelisation', value, this.currentModelisation.version);
        });
        this.$eventBus.$on('export-data-model', this.exportDataModel);
        this.$eventBus.$on('import-data-model', () => {
            this.importFileDialogOpen = true;
        });
        this.$eventBus.$on('on-create-new-model', this.createNewModel);
        this.$eventBus.$on('on-duplicate-model', this.duplicateModel);
        this.$eventBus.$on('save-schema', this.saveSchema);
        window.onbeforeunload = () => {
            if(this.schema.hasUnsavedChange()){
                return this.$t('instance.data_model.index.mounted.notification');
            }
        };
    },

    beforeDestroy (){
        this.$eventBus.$off('update-data-model');
        this.$eventBus.$off('export-data-model');
        this.$eventBus.$off('import-data-model');
        this.$eventBus.$off('on-create-new-model');
        this.$eventBus.$off('on-duplicate-model');
        this.$eventBus.$off('save-schema');
    },
    methods: {
        focusNode (nodeUid){
            this.$refs.graph.focusNode(nodeUid);
        },
        savePreviousModel() {
            // NON USED
            if (this.toggleEditType === 0) {
                this.$refs['schema-editor'].correctSyntaxAndSave(false);
            }
        },
        addModelToChanges(modelName) {
            this.schema.schemaHasError = true;
            if (!this.modelsToCheck.includes(modelName)) {
                this.modelsToCheck.push(modelName);
            }
        },
        removeModelFromChanges(modelName) {
            this.schema.schemaHasError = false;
            if (this.modelsToCheck.includes(modelName)) {
                this.modelsToCheck.splice(this.modelsToCheck.indexOf(modelName), 1);
            }
        },
        triggerCorrection() {
            this.$refs['schema-editor'].correctSyntaxAndSave();
        },
        async checkForNavigate (){
            if(this.schema.hasUnsavedChange()){
                this.$store.commit('CLEAN_MODEL_ERROR');
                return await this.$refs['modal-unsaved-change'].open();
            }else{
                this.$store.commit('CLEAN_MODEL_ERROR');
                return Promise.resolve();
            }
        },
        onModelisationImported (value){
            this.$refs['modal-check-datamodel'].open(value, this.currentModelisation.uid);
        },
        onModelisationCheckSuccessfully (value){
            this.$emit('update-schema-modelisation', value, this.currentModelisation.version);
        },
        saveSchema (){
            this.savePreviousModel();
            this.schema.reCreateRelations();
            if (this.schema.checkForDuplicateFields()){
                this.$refs['data-model-error'].open();
                this.$store.commit('SET_SAVE_STATE', 'error');
                return;
            }

            // Remove duplicate (sometime a bug create duplicate but it is not identified)
            this.schema.schema.manifest.data_modeling.many_to_many_relations = [...new Set(this.schema.schema.manifest.data_modeling.many_to_many_relations)];
            this.schema.schema.manifest.data_modeling.one_to_many_relations = [...new Set(this.schema.schema.manifest.data_modeling.one_to_many_relations)];

            // supprimes les provisionalFieldUid qui peuvent être sur les fields d'un model (apparait en cas d'erreur survenue sur un field)

            this.schema.removeProvisionalFieldsUid();
            this.schema.updatePermissionsNames();

            // this.schema.schema.manifest.data_modeling.one_to_one_relations = [...new Set(this.schema.schema.manifest.data_modeling.one_to_one_relations)];
            this.$store.commit('SET_SAVE_STATE', 'sync');
            this.schema.updateQueriesNames();
            this.$store.dispatch('patchItem', {
                item: {
                    url: this.currentModelisation.url,
                    value: this.schema.schema,
                },
                model: 'modelisations'
            }).then(() => {
                this.$store.commit('SET_SNACKBAR', {
                    color: 'success',
                    icon: 'done',
                    text: this.$t('instance.data_model.index.save_datamodel.success',{currentModelisation: this.currentModelisation.label }),
                });
                this.$store.commit('SET_SAVE_STATE', 'upToDate');
                this.$store.commit('SET_DISPLAY_SNACKBAR', true);
                this.schema.commit();
            }).catch((e) => {
                console.error(e);
                this.$store.commit('SET_SNACKBAR', {
                    color: 'error',
                    icon: 'error',
                    text: this.$t('instance.data_model.index.save_datamodel.error'),
                });
                this.$store.commit('SET_SAVE_STATE', 'error');
                this.$store.commit('SET_DISPLAY_SNACKBAR', true);
            }).finally(() => {
                this.schema.createProvisionalFieldsUid();
            });
        },

        switchModelisation (modelisation){
            this.$set(this, 'currentModelisation', modelisation);
            this.$refs['graph'].resetZoom();
            let selectedModelUid = this.schema.selectedModelUid;

            this.$emit('update-schema-modelisation', modelisation ? modelisation.value : {}, this.currentModelisation.version);
            this.schema.selectedModelUid = selectedModelUid;
        },
        pickFile () {
            this.$refs.image.click();
        },
        onFilePicked(e) {
            const files = e.target.files;
            if(files[0] !== undefined) {
                let reader = new FileReader();
                reader.onload = (file) => {
                    try{
                        let result = file.target.result;
                        let dataModel = YAML.parse(result);
                        this.onModelisationImported(dataModel);
                        this.importFileDialogOpen = false;
                        this.$refs.image.value = null;
                    }catch(e){
                        this.importedFileHasError = true;
                        console.error(e);
                    }
                };
                reader.readAsText(files[0]);
            }
        },
        exportDataModel() {
            const filename = `data-model.yaml`;
            let schema = JSON.parse(JSON.stringify((this.schema.schema)));
            schema = this.$helpers.removeProvisionalFieldsUid(schema);
            let data = YAML.stringify(schema);
            const yaml = YAML.parse(data);
            let element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(YAML.stringify(yaml)));
            element.setAttribute('download', filename);
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        },

        createNewModel (newModelName){
            this.schema.createNewModel(newModelName);
        },
        duplicateModel (selectedDuplicateModel){
            this.schema.duplicateModel(selectedDuplicateModel);
        },
    },
};
</script>

<style lang="scss">
.view-data-model{
    .schema-container{
        display: flex;
        flex-wrap: wrap;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Instance/DataModel/index.vue